import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Domain_LocalResourcesDefinition  {
    _originalTypeClassName = "zSHR.BO.Domain_LocalResourcesDefinition";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Domain_LocalResourcesDefinition.translate = translateService;
}
this.RequestHelperBO_RES_CUSTOM_EMPLOYEE_NOT_FOUND = null;
this.Res_ENUM_Gender_Male = null;
this.Res_ENUM_Gender_Female = null;
this.Res_ENUM_Gender_Other = null;
this.Res_ENUM_FamilyStatus_Single = null;
this.Res_ENUM_FamilyStatus_Married = null;
this.Res_ENUM_FamilyStatus_Divorced = null;
this.Res_ENUM_FamilyStatus_Widowed = null;
this.Res_ENUM_CEFRLevel_A1 = null;
this.Res_ENUM_CEFRLevel_A2 = null;
this.Res_ENUM_CEFRLevel_B1 = null;
this.Res_ENUM_CEFRLevel_B2 = null;
this.Res_ENUM_CEFRLevel_C1 = null;
this.Res_ENUM_CEFRLevel_C2 = null;
this.Res_ENUM_RequestStates_Request = null;
this.Res_ENUM_RequestStates_Approved = null;
this.Res_ENUM_RequestStates_Rejected = null;
this.Res_ENUM_RequestStates_Correction = null;
this.Res_ENUM_CertificationStatus_Active = null;
this.Res_ENUM_CertificationStatus_Inactive = null;
this.Res_ENUM_Relationship_Child = null;
this.Res_ENUM_Relationship_Spouse = null;
this.Res_ENUM_Relationship_Parent = null;
this.Res_ENUM_Relationship_Sibling = null;
this.Res_ENUM_DepMemberEducation_No = null;
this.Res_ENUM_DepMemberEducation_SecondStep = null;
this.Res_ENUM_DepMemberEducation_ThirdStep = null;
this.SHRChangeRequestBO_Res_ASSOC_Employee_EmployeeDataChangeRequest_Employee = null;
this.Res_ENUM_EmployeeDataChangeRequestStatus_Pending = null;
this.Res_ENUM_EmployeeDataChangeRequestStatus_Accepted = null;
this.Res_ENUM_EmployeeDataChangeRequestStatus_Rejected = null;
this.Res_ENUM_LeaveRequestStatus_Temporary = null;
this.Res_ENUM_LeaveRequestStatus_Pending = null;
this.Res_ENUM_LeaveRequestStatus_Validating = null;
this.Res_ENUM_LeaveRequestStatus_Approved = null;
this.Res_ENUM_LeaveRequestStatus_Rejected = null;
this.Res_ENUM_LeaveRequestStatus_Cancelled = null;
this.Res_ENUM_HolidayType_ByLaw = null;
this.Res_ENUM_HolidayType_Company = null;
this.Res_ENUM_PendingTaskType_ApproveLeave = null;
this.Res_ENUM_PendingTaskType_CheckLeaveData = null;
this.Res_ENUM_PendingTaskType_Information = null;
this.Res_ENUM_OvertimeType_Overtime = null;
this.Res_ENUM_OvertimeType_Overwork = null;
}

static translate: TranslateService;
_key: any;
RequestHelperBO_RES_CUSTOM_EMPLOYEE_NOT_FOUND:any;
Res_ENUM_Gender_Male:any;
Res_ENUM_Gender_Female:any;
Res_ENUM_Gender_Other:any;
Res_ENUM_FamilyStatus_Single:any;
Res_ENUM_FamilyStatus_Married:any;
Res_ENUM_FamilyStatus_Divorced:any;
Res_ENUM_FamilyStatus_Widowed:any;
Res_ENUM_CEFRLevel_A1:any;
Res_ENUM_CEFRLevel_A2:any;
Res_ENUM_CEFRLevel_B1:any;
Res_ENUM_CEFRLevel_B2:any;
Res_ENUM_CEFRLevel_C1:any;
Res_ENUM_CEFRLevel_C2:any;
Res_ENUM_RequestStates_Request:any;
Res_ENUM_RequestStates_Approved:any;
Res_ENUM_RequestStates_Rejected:any;
Res_ENUM_RequestStates_Correction:any;
Res_ENUM_CertificationStatus_Active:any;
Res_ENUM_CertificationStatus_Inactive:any;
Res_ENUM_Relationship_Child:any;
Res_ENUM_Relationship_Spouse:any;
Res_ENUM_Relationship_Parent:any;
Res_ENUM_Relationship_Sibling:any;
Res_ENUM_DepMemberEducation_No:any;
Res_ENUM_DepMemberEducation_SecondStep:any;
Res_ENUM_DepMemberEducation_ThirdStep:any;
SHRChangeRequestBO_Res_ASSOC_Employee_EmployeeDataChangeRequest_Employee:any;
Res_ENUM_EmployeeDataChangeRequestStatus_Pending:any;
Res_ENUM_EmployeeDataChangeRequestStatus_Accepted:any;
Res_ENUM_EmployeeDataChangeRequestStatus_Rejected:any;
Res_ENUM_LeaveRequestStatus_Temporary:any;
Res_ENUM_LeaveRequestStatus_Pending:any;
Res_ENUM_LeaveRequestStatus_Validating:any;
Res_ENUM_LeaveRequestStatus_Approved:any;
Res_ENUM_LeaveRequestStatus_Rejected:any;
Res_ENUM_LeaveRequestStatus_Cancelled:any;
Res_ENUM_HolidayType_ByLaw:any;
Res_ENUM_HolidayType_Company:any;
Res_ENUM_PendingTaskType_ApproveLeave:any;
Res_ENUM_PendingTaskType_CheckLeaveData:any;
Res_ENUM_PendingTaskType_Information:any;
Res_ENUM_OvertimeType_Overtime:any;
Res_ENUM_OvertimeType_Overwork:any;




}